import { useState } from "react";
import { uploadFile, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function useUpload() {
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    setBusy(true);
    try { const rec = await uploadFile(file); return rec; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Upload failed"); return null; }
    finally { setBusy(false); }
  };
  return { upload, busy };
}
